import { render } from "./CompanyPlan.vue?vue&type=template&id=b9697ace&scoped=true&ts=true"
import script from "./CompanyPlan.vue?vue&type=script&lang=ts"
export * from "./CompanyPlan.vue?vue&type=script&lang=ts"

import "./CompanyPlan.vue?vue&type=style&index=0&id=b9697ace&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9697ace"]])

export default __exports__